'use client';

import clsx from 'clsx';
import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from '../../forward-ref.js';
import { withStyleProps } from '../../with-style-props.js';
import { FocusableContainer } from '../internal/focusable-container/focusable-container.js';
import type { AriaLabelingProps, CommonProps } from '../types.js';

export interface TableContainerProps extends CommonProps, AriaLabelingProps {
  /** The contents of the container. */
  children: ReactNode;
}

function TableContainer(
  { children, UNSAFE_className, UNSAFE_style, ...props }: TableContainerProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <FocusableContainer
      {...props}
      ref={ref}
      className={clsx('cim-table-container', UNSAFE_className)}
      style={UNSAFE_style}
      scrollDirection="horizontal"
    >
      {children}
    </FocusableContainer>
  );
}

/**
 * Renders a scrollable container that allows a table to overflow in a responsive way.
 *
 * See [table usage guidelines](https://ui.cimpress.io/components/table/) and [table building guide](https://ui.cimpress.io/dev-guides/tables/).
 */
const _TableContainer = withStyleProps(forwardRef(TableContainer), 'TableContainer');

export { _TableContainer as TableContainer };
